import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { AllWidgets, DeviceDetail } from "./";
import { ModalComp } from "../";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";
import { FiCheck, FiArrowLeft, FiGrid, FiBox } from "react-icons/fi";

const WidgetsJoined = () => {
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const deviceWidgetsJoined = useSelector((state) => state.deviceWidgetsJoined);
  const [openDeviceDetails, setOpenDeviceDetails] = useState(false);
  const toggleDeviceDetails = () => setOpenDeviceDetails(!openDeviceDetails);
  const { t } = useTranslation();

  return (
    <>
      <ModalComp
        modal={openDeviceDetails}
        toggle={toggleDeviceDetails}
        component={<DeviceDetail />}
        dark={true}
      />
      
      <div className="widgets-joined-container">


        {/* Widgets List */}
        <div className="widgets-joined-list">
          {deviceWidgetsJoined?.map((widget, index) => {
            if (widget["property"][3]) {
              return (
                <AllWidgets
                  key={index}
                  widget={widget}
                  num={index + 1}
                  toggleDeviceDetails={toggleDeviceDetails}
                />
              );
            }
          })}
        </div>

        {/* Action Buttons */}
        <div className="setting-buttons">
          <button
            type="button"
            className="setting-back-btn"
            onClick={() => ShowHideDeviceFunction("allDevices")}
            style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
          >
            <FiArrowLeft size={18} />
            <span>{t("بازگشت")}</span>
          </button>
          <button
            type="button"
            className="setting-back-btn"
            onClick={() => ShowHideDeviceFunction("endPage")}
          >
            <FiCheck size={18} />
            <span>{t("بعدی")}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export { WidgetsJoined };